import axios from "../utils/AxiosInstance";
import { ResponseMessage } from "../models/ResponseMessage";
import { Constants } from "../constants/constants";
import {
  CreateServiceRequest,
  Service,
  ServiceBranchAssignment,
  ServiceUpdateModel,
} from "../models/ServiceModels";

const API_BASE_URL = Constants.API_BASE_URL;

export async function getServicesByOrganizationAsync(
  organizationId: string,
): Promise<ResponseMessage<Service[]>> {
  const response = await axios.get(
    `${API_BASE_URL}/services/organization/${organizationId}`,
  );

  return ResponseMessage.fromJson(response.data);
}

export async function getServiceAsync(
  id: string,
): Promise<ResponseMessage<Service>> {
  const response = await axios.get(`${API_BASE_URL}/services/${id}`);

  return ResponseMessage.fromJson(response.data);
}

const appendBranches = (formData: FormData, branches?: ServiceBranchAssignment[] | null) => {
  branches?.forEach((branch, index) => {
    formData.append(`branches[${index}].branchId`, branch.branchId);
    if (branch.price != null) {
      formData.append(`branches[${index}].price`, String(branch.price));
    }
    if (branch.durationMinutes != null) {
      formData.append(
        `branches[${index}].durationMinutes`,
        String(branch.durationMinutes),
      );
    }
    formData.append(`branches[${index}].isActive`, String(branch.isActive));
  });
};

export async function createServiceAsync(
  token: string,
  request: CreateServiceRequest,
): Promise<ResponseMessage<Service>> {
  const formData = new FormData();
  formData.append("organizationId", request.organizationId);
  formData.append("name", request.name);
  formData.append("description", request.description ?? "");
  formData.append("category", request.category ?? "");
  formData.append("durationMinutes", String(request.durationMinutes));
  formData.append("price", String(request.price));
  formData.append("currency", request.currency);
  formData.append("isActive", String(request.isActive));
  formData.append("sortOrder", String(request.sortOrder));
  if (request.imageFile) formData.append("imageFile", request.imageFile);
  appendBranches(formData, request.branches);

  const response = await axios.post(`${API_BASE_URL}/services`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return ResponseMessage.fromJson(response.data);
}

export async function updateServiceAsync(
  token: string,
  id: string,
  model: ServiceUpdateModel,
): Promise<ResponseMessage<Service>> {
  const formData = new FormData();
  if (model.name) formData.append("name", model.name);
  if (model.description) formData.append("description", model.description);
  if (model.category) formData.append("category", model.category);
  if (model.durationMinutes != null) {
    formData.append("durationMinutes", String(model.durationMinutes));
  }
  if (model.price != null) formData.append("price", String(model.price));
  if (model.currency) formData.append("currency", model.currency);
  if (model.isActive != null) formData.append("isActive", String(model.isActive));
  if (model.sortOrder != null) formData.append("sortOrder", String(model.sortOrder));
  if (model.imageUrl) formData.append("imageUrl", model.imageUrl);
  if (model.imageFile) formData.append("imageFile", model.imageFile);
  appendBranches(formData, model.branches);

  const response = await axios.put(`${API_BASE_URL}/services/${id}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return ResponseMessage.fromJson(response.data);
}

export async function deleteServiceAsync(
  token: string,
  id: string,
): Promise<ResponseMessage<boolean>> {
  const response = await axios.delete(`${API_BASE_URL}/services/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return ResponseMessage.fromJson(response.data);
}
